import makeQueryKey from "../../../../utils/make-query-key";
export var PAYPAL_EXPRESS_QUERY_KEY = 'payment/paypal_express/v2';
var getPaypalExpressQueryKey = function getPaypalExpressQueryKey(_ref) {
  var totals = _ref.totals,
    items = _ref.items;
  return makeQueryKey([PAYPAL_EXPRESS_QUERY_KEY, {
    totals: totals,
    items: items
  }]);
};
export default getPaypalExpressQueryKey;